/*
 * Below code needs to be replaced
 * For anyone seeing this, this was not implemented by peanutbutter.es, but by trifork.com, worst coders ever.
 * Below code may not be so terrible, because the worst parts have been refactored
 */
var hasProductsOnSearch = false;
var currentProductSelection = 0;
var totalProductOnSearch = 0;
var listProductsSearch = null;
var productsIdsOnCart = [];
var totalProductsRecommendation = 0;

let recomendedCarouselProducts;
var loadedCarouselRecomended = false;

(function ($) {
  $(function () {

    /* ['tier:refresh', 'cart:refresh'].forEach(eventName => {
      document.addEventListener(eventName, () => getCart());
    }); */

    if (window.location.search == '?open=cart') {
      $('#cart-area').removeClass('hidden').addClass('flex');
      getRecommendations(productsIdsOnCart);
    }

    // SEARCH BAR
    $('#search-desktop, #search-mobile').on('keyup', (evt) => {
      if (evt.keyCode === 13) {
        window.location.href = `${window.routes.search_url}?q=${evt.target.value}`;
      }
    });

    // LANGUAGE DROPDOWN
    $('#language').on('click', () => {
      $('#language-selector').toggle();
    });

    // PRODUCTS ON HEADER
    $('#collapse-menu').on('click', (event) => {
      if ($(window).innerWidth() < 1024) {
        $('#menu #detail-dropdown-products').css({ left: -17 }).show();
      }

      $('#menu').toggle();
    });

    $('#menu-products').on('mouseenter click', (event) => {
      const parentPosition = $(event.target).offset();
      if ($(window).innerWidth() > 700) {
        $('#menu #detail-dropdown-products').css({ left: (parentPosition.left) }).show()
      } else {
        $('#menu #detail-dropdown-products').css({ left: '' }).show()
      }
      $('#menu').show();
    });

    $('#menu').on('mouseleave', (event) => {
      $('#menu').hide();
    })

    // MOBILE MENU
    $('[data-click]').on('click', (event) => {
      const value = event.target.dataset.click;
      $(event.target).find('img.arrow').removeClass('-rotate-90 pointer-events-none');
      $(`[data-toggle=${value}]`).toggle();

      if (!$(`[data-toggle=${value}]`).is(':visible')) {
        $(event.target).find('img.arrow').addClass('-rotate-90 pointer-events-none')
      }
    });

    $('.add-to-cart').on('click', (evt) => {
      const cart = document.querySelector('cart-drawer');
      const parent = $(evt.target).parents('.product-description');
      const ID = $(parent).find('input[name="productId"]').val();
      const title = $(parent).find('input[name="productTitle"]').val();

      const quantity = $(parent).find('input[name="quantity"]').eq(0).length ? $(parent).find('input[name="quantity"]').val() : 1;

      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity,
          id: ID
        },
        dataType: 'json',
        success: function (data) {
          window.showToast(`${window.globalTranslations.addToCart}: ${title} `);
        },
        error: function (data) {
          window.showToast(data.responseJSON.description, 'error');
        },
        complete: function () {
          getCart();
          if(cart){
            cart.updateCart();
          }
        }
      });
    });

    $('#cart-icon-bubble').on('click', async () => {
      await getCart();

      if ($('#cart-area').is(':visible')) {
        $('#cart-area').removeClass('flex').addClass('hidden');
      } else {
        $('#cart-area').removeClass('hidden').addClass('flex');
        //$('.owl-carousel-recommended-products').html(' ');
        getRecommendations(productsIdsOnCart);
      }
    });

    $('[data-item]').on('click', (evt) => {
      let value = $(evt.target).attr('data-href').toLowerCase();
      window.location.href = `${window.shopUrl}/collections/types?q=${value}`;
    });

    // CAROUSEL NEW ITEMS
    const owlNewItems = $('.owl-carousel-new-items').owlCarousel({
      loop: false,
      nav: false,
      dots: false,
      margin: 16,
      autoWidth: true,
      responsive: {
        0: {
          items: 1.5,
        },
        600: {
          items: 3
        },
        1000: {
          items: 4
        }
      }
    });

    $('.owl-new-items-next-button').click(function () {
      owlNewItems.trigger('next.owl.carousel');
    });
    $('.owl-new-items-prev-button').click(function () {
      owlNewItems.trigger('prev.owl.carousel');
    });

    $('.owl-carousel-new-items .owl-stage').css('display', 'flex');

        // CAROUSEL TOP VENTAS
        const owlTopItems = $('.owl-carousel-top-ventas').owlCarousel({
          loop: false,
          nav: false,
          dots: false,
          margin: 16,
          autoWidth: true,
          responsive: {
            0: {
              items: 3,
            },
            600: {
              items: 3
            },
            1000: {
              items: 4
            }
          }
        });
    
        $('.owl-top-ventas-next-button').click(function () {
          owlTopItems.trigger('next.owl.carousel');
        });
        $('.owl-top-ventas-prev-button').click(function () {
          owlTopItems.trigger('prev.owl.carousel');
        });
    
        $('.owl-carousel-top-ventas .owl-stage').css('display', 'flex');

    // CAROUSEL PACKS
    const owlPacks = $('.owl-carousel-packs').owlCarousel({
      loop: false,
      nav: false,
      dots: false,
      margin: 16,
      autoWidth: true,
      responsive: {
        0: {
          items: 3,
        },
        600: {
          items: 3
        },
        1000: {
          items: 4
        }
      }
    });

    $('.owl-packs-next-button').click(function () {
      owlPacks.trigger('next.owl.carousel');
    });
    $('.owl-packs-prev-button').click(function () {
      owlPacks.trigger('prev.owl.carousel');
    });

    $('.owl-carousel-packs .owl-stage').css('display', 'flex');

    // CAROUSEL BRANDS
    const owlBrands = $('.owl-carousel-brands').owlCarousel({
      loop: false,
      nav: false,
      dots: false,
      responsive: {
        0: {
          items: 3,
        },
        600: {
          items: 3
        },
        1000: {
          items: 5
        }
      }
    });

    $('.owl-brands-next-button').click(function () {
      owlBrands.trigger('next.owl.carousel');
    });
    $('.owl-brands-prev-button').click(function () {
      owlBrands.trigger('prev.owl.carousel');
    });

    // CAROUSEL INSPIRATION
    const owl = $('.owl-carousel-inspiration').owlCarousel({
      stagePadding: 0,
      loop: false,
      margin: 16,
      nav: false,
      dots: false,
      autoWidth: true,
      responsive: {
        0: {
          items: 1,
          margin: 8,
        },
        600: {
          items: 3
        },
        1000: {
          items: 2
        }
      }
    });

    $('.owl-inspiration-next-button').click(function () {
      owl.trigger('next.owl.carousel');
    });
    $('.owl-inspiration-prev-button').click(function () {
      owl.trigger('prev.owl.carousel');
    });

    $('.owl-recommended-next-button').click(function () {
      recomendedCarouselProducts.trigger('next.owl.carousel');
    });
    $('.owl-recommended-prev-button').click(function () {
      recomendedCarouselProducts.trigger('prev.owl.carousel');
    });

    // CAROUSEL TESTIMONIALS
    const owlTestimonials = $('.owl-carousel-testimonial').owlCarousel({
      loop: false,
      nav: false,
      dots: false,
      margin: 0,
      responsive: {
        0: {
          items: 1,
        },
        600: {
          items: 1
        },
        1000: {
          items: 1
        }
      }
    });

    $('.owl-carousel-testimonial-next-button').click(function () {
      owlTestimonials.trigger('next.owl.carousel');
    });
    $('.owl-carousel-testimonial-prev-button').click(function () {
      owlTestimonials.trigger('prev.owl.carousel');
    });

    // CAROUSEL ON SALE PRODUCTS
    const owlOnSale = $('.owl-carousel-random-product').owlCarousel({
      loop: false,
      nav: false,
      dots: false,
      margin: 0,
      responsive: {
        0: {
          items: 1,
        },
        600: {
          items: 1
        },
        1000: {
          items: 1
        }
      }
    });

    $('.owl-carousel-onsale-next-button').click(function () {
      owlOnSale.trigger('next.owl.carousel');
    });
    $('.owl-carousel-onsale-prev-button').click(function () {
      owlOnSale.trigger('prev.owl.carousel');
    });

    // NEWSLETTER FORM
    $('#newsletterSubmit').on('click', () => {
      const $form = $('#contact_form');
      const regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;

      const email = regex.test($($form).find('input[name="contact[email]"]').val());
      const agree = $($form).find('input[name="contact[agree_tos]"]').is(':checked');

      $($form).find('#newsletter-error-form').addClass('invisible');
      $($form).find('input[name="contact[email]"]').removeClass('text-error').addClass('text-primary');

      if (email && agree) {
        $($form).submit();
        return;
      }

      $($form).find('#newsletter-error-form').removeClass();
      $($form).find('input[name="contact[email]"]').removeClass('text-primary').addClass('text-error');
    });

    // FILTER SORT BY
    $('button.filter').on('click', (evt) => {
      const target = evt.target.dataset.filter;
      $(`[data-toggle=${target}]`).toggle();
    });

    if ($('.grid-items').hasClass('grid-cols-2')) {
      if (window.innerWidth < 600) {
        $('.grid-items .restriction cite').hide();
      }
    }

    $('.grid-option').on('click', (evt) => {
      const value = evt.target.dataset.value;
      const gridCollection = document.querySelector('[data-product-grid]')

      $('.grid-items').removeClass('grid-cols-2');
      $('.grid-option').removeClass('active')
      $(evt.target).addClass('active');

      if (value === '2-per-line') {
        // $('.grid-items').removeClass('grid-cols-1').addClass('grid-cols-2');
        $('.grid-items .restriction cite').hide();
        gridCollection.classList.add('horizontal')
        gridCollection.classList.remove('vertical')
      } else if (value === 'horizontal') {
        // $('.grid-items').removeClass('grid-cols-1').addClass('grid-cols-2');
        $('.grid-items .restriction cite').hide();
        gridCollection.classList.add('horizontal')
        gridCollection.classList.remove('vertical')
      } else {
        // $('.grid-items').removeClass('grid-cols-2').addClass('grid-cols-1');
        $('.grid-items .restriction cite').show();
        gridCollection.classList.remove('horizontal')
        gridCollection.classList.add('vertical')
      }
    });

    // change quantity inside the product
    $('.list-quantity-inside-product [data-action="decrease"]').on('click', (evt) => {
      var id = $(evt.currentTarget).attr('data-variant-id');
      var currentQuantity = parseInt($(evt.currentTarget).parent('.list-quantity-inside-product').find('h3').text());

      if (currentQuantity) {
        var quantity = parseInt(currentQuantity) - 1
        updateFromCart(id, quantity);

        if (quantity === 0) {
          $(`.product-description[data-id="${id}"]`).find('.list-quantity-inside-product').addClass('hidden');
          $(`.product-description[data-id="${id}"]`).find('.product-button-add-cart').show();

          if (window.innerWidth < 500) {
            $(`.product-description[data-id="${id}"]`).find('.reviews-area').show();
          }
        }
      }
    });

    $('.list-quantity-inside-product [data-action="increase"]').on('click', (evt) => {
      var id = $(evt.currentTarget).attr('data-variant-id');
      var totalMaxQuantity = $(evt.currentTarget).attr('data-max-quantity');
      var currentQuantity = $(evt.currentTarget).parent('.list-quantity-inside-product').find('h3').text();

      if (parseInt(currentQuantity) <= parseInt(totalMaxQuantity)) {
        var quantity = parseInt(currentQuantity) + 1;
        updateFromCart(id, quantity);
      }
    });
  });

  getCart();

  function renderItemsOnCart(item) {
    console.log('renderItemsOnCart')
    /* let quantity = item.quantity;

    const itemCart = `
            <div class="item-cart flex" data-id="${item.variant_id}">
                <figure>
                    <img src="${item.image}" alt="" class="invisible" />
                    <div class="absolute bg-white" style="margin: -40%; top: 50%; left: 50%; background: url('${item.image}') no-repeat; flex: none; width: 80%; height: 80%; mix-blend-mode: multiply; background-blend-mode: multiply; background-size: cover;"></div>
                </figure>

                <div class="product-detail">
                    <div class="flex flex-row">
                        <div class="flex w-full gap-0.5">
                            <p class="text-ellipsis overflow-hidden whitespace-nowrap max-w-[60%]">${item.product_title}</p>
                            <p>${item.variant_title ? ` - ${item.variant_title}` : ''}
                        </div>
                        <button class="ml-auto" data-action="remove-from-cart" data-variant-id="${item.variant_id}">
                            ${DeleteIcon()}
                        </button>
                    </div>

                    <div class="flex flex-row flex-end items-center">
                        <div class="flex quantity mt-2">
                            <button type="button" class="bg-primary text-white" data-action="decrease-quantity" data-variant-id="${item.variant_id}">-</button>
                            <h3 class="flex justify-center items-center" data-quantity="${quantity}">${quantity}</h3>
                            <button type="button" class="bg-primary text-white" data-action="increase-quantity" data-variant-id="${item.variant_id}">+</button>
                        </div>
                        <p class="ml-auto" data-updated-event>
                            <span class="total-on-quantity">${quantity > 1 ? `${quantity}x` : ''}</span>
                            ${item.original_price !== item.final_price ? 
                              `<s class="cart-item__old-price product-option">${Shopify.formatMoney(item.original_price, "{{amount}}€")}</s>
                               <strong class="cart-item__final-price product-option">${Shopify.formatMoney(item.final_price, "{{amount}}€")}</strong>` 
                              : 
                              `${Shopify.formatMoney(item.price, "{{amount}}€")}`
                            }
                        </p>
                    </div>
                </div>
            </div>
        `;
    return itemCart; */
  }

  function getCart() {
    console.log('GET CARTTTTTT')
    fetch('/cart.js', {
      method: 'GET',
      credentials: 'same-origin',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      return response.json();
    })
    .then(data => {
      for (let i = 0; i < data.items.length; i++) {
        if (!productsIdsOnCart.includes(data.items[i].product_id)) {
          productsIdsOnCart.push(data.items[i].product_id);
        }
      }
      
      localStorage.removeItem('current-cart');

      if (data.items.length) {
        localStorage.setItem('current-cart', JSON.stringify(data.items));
      }
      
    })
    .catch(error => {
      console.error("ERROR FETCH:");
      console.error('Error en la solicitud fetch:', error);
    })
    .finally(() => {
      console.log('finalizando')
      handleItems();
      populateQuantity();
    });
  }

  document.addEventListener('cart:errorAddItem', () => getCart());

  function DeleteIcon() {
    return `
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" style="pointer-events: none;">
            <path d="M4.31644 14.1C4.00533 14.1 3.73866 13.9861 3.51644 13.7583C3.29422 13.5305 3.18311 13.2667 3.18311 12.9667V3.53332H2.99977C2.83311 3.53332 2.69699 3.47776 2.59144 3.36665C2.48588 3.25554 2.43311 3.12221 2.43311 2.96665C2.43311 2.79998 2.48588 2.66387 2.59144 2.55832C2.69699 2.45276 2.83311 2.39998 2.99977 2.39998H5.73311C5.73311 2.23332 5.78866 2.09443 5.89977 1.98332C6.01088 1.87221 6.14422 1.81665 6.29977 1.81665H9.69977C9.85533 1.81665 9.98866 1.87221 10.0998 1.98332C10.2109 2.09443 10.2664 2.23332 10.2664 2.39998H12.9998C13.1664 2.39998 13.3025 2.45554 13.4081 2.56665C13.5137 2.67776 13.5664 2.81109 13.5664 2.96665C13.5664 3.13332 13.5137 3.26943 13.4081 3.37498C13.3025 3.48054 13.1664 3.53332 12.9998 3.53332H12.8164V12.9667C12.8164 13.2667 12.7053 13.5305 12.4831 13.7583C12.2609 13.9861 11.9942 14.1 11.6831 14.1H4.31644ZM4.31644 3.53332V12.9667H11.6831V3.53332H4.31644ZM6.06644 11.0333C6.06644 11.1778 6.11922 11.3028 6.22477 11.4083C6.33033 11.5139 6.45533 11.5667 6.59977 11.5667C6.75533 11.5667 6.88311 11.5139 6.98311 11.4083C7.08311 11.3028 7.13311 11.1778 7.13311 11.0333V5.44998C7.13311 5.30554 7.08033 5.18054 6.97477 5.07498C6.86922 4.96943 6.74422 4.91665 6.59977 4.91665C6.44422 4.91665 6.31644 4.96943 6.21644 5.07498C6.11644 5.18054 6.06644 5.30554 6.06644 5.44998V11.0333ZM8.86644 11.0333C8.86644 11.1778 8.91922 11.3028 9.02477 11.4083C9.13033 11.5139 9.25533 11.5667 9.39977 11.5667C9.55533 11.5667 9.68311 11.5139 9.78311 11.4083C9.88311 11.3028 9.93311 11.1778 9.93311 11.0333V5.44998C9.93311 5.30554 9.88311 5.18054 9.78311 5.07498C9.68311 4.96943 9.55533 4.91665 9.39977 4.91665C9.24422 4.91665 9.11644 4.96943 9.01644 5.07498C8.91644 5.18054 8.86644 5.30554 8.86644 5.44998V11.0333ZM4.31644 3.53332V12.9667V3.53332V3.53332Z" fill="black"/>
            </svg>
        `;
  }

  function handleItems() {
    console.log('handleItems')
    /* $('button[data-action="remove-from-cart"]').on('click', (evt) => {
      const variantId = $(evt.target).attr('data-variant-id');

      removeFromCart(variantId)
    });

    $('button[data-action="decrease-quantity"]').on('click', (evt) => {
      const parent = $(evt.target).parents('.item-cart');
      const variantId = $(evt.target).attr('data-variant-id');
      let quantity = parseInt($(parent).find('.quantity h3').text()) - 1;

      updateFromCart(variantId, quantity)
    });
    $('button[data-action="increase-quantity"]').on('click', (evt) => {
      const parent = $(evt.target).parents('.item-cart');
      const variantId = $(evt.target).attr('data-variant-id');
      let quantity = parseInt($(parent).find('.quantity h3').text()) + 1;

      updateFromCart(variantId, quantity)
    });
 */

  }
  function UpdateQuantityModal(productId, quantity, variantId) {
    console.log('updateQuantityModal')
    /* fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        id: variantId,
        quantity: quantity,
      }),
    })
    .then((response) => response.json())
    .then((data) => {
      const buttonActive = document.querySelector(`modal-card-opener[data-product-id="${productId}"]`);
      buttonActive.loadModalContent('line-item')
      buttonActive.updateButtons();
    })
    .catch((error) => {
      console.error(error);
    }); */
  }



  function handleEventUpdateCart(){
    console.log('handleEventUpdateCart')
    /* const messageEvent = new CustomEvent("cart:refresh", {
      bubbles: true,
      composed: true,
      detail: { timestamp: new Date().getTime() }
    });
    document.dispatchEvent(messageEvent); */
  }

  function removeFromCart(variantId) {
    console.log('removeFromCart')
    /* $.ajax({
      type: "POST",
      url: "/cart/change.js",
      dataType: "json",
      data: {
        id: parseFloat(variantId),
        quantity: 0,
      },
      success: function (response) {
        $(`#list-cart [data-id="${variantId}"]`).remove();
        updateQuantityOnProduct(variantId);

        $('#total-amount p span').text(`${Shopify.formatMoney(response.total_price, "{{amount}}€")}`);

        $('#checkout-available').hide();
        $('#checkout-unavailable').show();

        localStorage.removeItem('current-cart');
        if (response.items.length) {
          $('#checkout-available').show();
          $('#checkout-unavailable').hide();

          localStorage.setItem('current-cart', JSON.stringify(response.items));
        }

        if (response.item_count) {
          $('#total-on-cart').text(response.item_count).css('display', 'flex');
        }
        handleEventUpdateCart();        
      },
      complete: function () {
        populateQuantity();
      }
    }) */
  }

  function updateProductCardPrice(variantId, finalPrice, hasDiscount = false) {
    console.log('updateProductCardPrice')
    /* const cardProduct = document.querySelector(`.product-description[data-id="${variantId}"]`);
    if (!cardProduct) return;
  
    const priceBoxPrivate = cardProduct.querySelector('.c-cp__price__pricebox[data-private-event]');
    const priceBoxBusiness = cardProduct.querySelector('.c-cp__price__pricebox[data-business-event]');
    const pricePerUnitPrivate = cardProduct.querySelector('.c-cp__price__perunit__t[data-private-event]');
    const pricePerUnitBusiness = cardProduct.querySelector('.c-cp__price__perunit__t[data-business-event]');
    const pricePerType = cardProduct.querySelector('price-per-type');
    const priceMain = cardProduct.querySelector('[data-event-main-price]');
  
    if (priceBoxPrivate) {
      const unitPerTypeAttr = parseFloat(priceBoxPrivate.getAttribute('data-unit-per-type'));
      const ivaAttr = priceBoxPrivate.getAttribute('data-iva');

      const iva = parseFloat(ivaAttr);
      const priceEl = priceBoxPrivate.querySelector('.c-cp__price__pricebox__price');
      const priceWithIva = parseFloat(finalPrice) * (1 + iva / 100);
  
      if (priceEl && !isNaN(iva)) {
        const priceWithUnit = priceWithIva / unitPerTypeAttr;

        if(!priceBoxPrivate.classList.contains('c-cp__price__pricebox--sale')){
          priceEl.closest('.c-cp__price__pricebox').style.color = hasDiscount ? '#f44336' : '#000';
        }
        priceEl.textContent = `${Shopify.formatMoney(priceWithIva, "{{amount}}€")}`;

        if (pricePerUnitPrivate) {
          if(!priceBoxPrivate.classList.contains('c-cp__price__pricebox--sale')){
            pricePerUnitPrivate.style.color = hasDiscount ? '#f44336' : '#000';
          }
          if(priceMain && priceMain.classList.contains('hidden')){
            pricePerUnitPrivate.textContent = `${Shopify.formatMoney(priceWithUnit, "{{amount}}€")}/Und.`;
          }else{
            pricePerUnitPrivate.textContent = `(${Shopify.formatMoney(priceWithUnit, "{{amount}}€")}/Und.)`;
          }
        }
      }

      if (priceBoxBusiness) {
        const priceEl = priceBoxBusiness.querySelector('.c-cp__price__pricebox__price');
        const priceWithUnit = parseFloat(finalPrice) / unitPerTypeAttr;

        if (priceEl) {

          if(!priceBoxBusiness.classList.contains('c-cp__price__pricebox--sale')){
            priceEl.closest('.c-cp__price__pricebox').style.color = hasDiscount ? '#f44336' : '#000';
          }
            priceEl.textContent = `${Shopify.formatMoney(finalPrice, "{{amount}}€")}`;
        }

        if(pricePerUnitBusiness){
          if(!priceBoxBusiness.classList.contains('c-cp__price__pricebox--sale')){
            pricePerUnitBusiness.style.color = hasDiscount ? '#f44336' : '#000';
          }
          if(priceMain && priceMain.classList.contains('hidden')){
            pricePerUnitBusiness.textContent = `${Shopify.formatMoney(priceWithUnit, "{{amount}}€")}/Und.`;
          }else{
            pricePerUnitBusiness.textContent = `(${Shopify.formatMoney(priceWithUnit, "{{amount}}€")}/Und.)`;
          }
        }
        if(pricePerType){
          setTimeout(() => {
            if (pricePerType?.changePriceForType) {
              pricePerType.changePriceForType(priceWithIva, finalPrice);
            }
          }, 300);
        }
      }
    }
   */
  }
  

  function updateFromCart(variantId, quantity) {
    console.log('update fron cart')
    /* $.ajax({
      type: "POST",
      url: "/cart/change.js",
      dataType: "json",
      data: {
        id: parseFloat(variantId),
        quantity: quantity,
      },
      success: function (response) {
        let quantityOld = 0;
        if (quantity == 0) {
          $(`#list-cart [data-id="${variantId}"]`).remove();
          updateQuantityOnProduct(variantId);
        } else {
          populateQuantity();
          // Encontrar el item actual en la respuesta
          var current = response.items.filter((value) => value.id === parseFloat(variantId))[0];

          if (current) {
            const cartItem = $(`#list-cart [data-id="${variantId}"]`);
            quantityOld = parseFloat(cartItem.find('.quantity h3').text());
            // Actualizar la cantidad
            cartItem.find('.quantity h3').text(quantity).attr('data-quantity', quantity);
            
            // Determinar si hay un precio con descuento
            const hasDiscount = (
              (current.original_price && current.final_price && current.original_price !== current.final_price) || 
              (current.original_line_price && current.final_line_price && current.original_line_price !== current.final_line_price) ||
              (current.compare_at_price && current.price && current.compare_at_price > current.price)
            );

            // Obtener el precio original y con descuento
            let originalPrice = current.original_price || current.compare_at_price || (current.original_line_price ? current.original_line_price / quantity : null);
            let finalPrice = current.final_price || current.price || (current.final_line_price ? current.final_line_price / quantity : current.price);
            
            //updateProductCardPrice(variantId, finalPrice)
                            
            // Actualizar el HTML de precios
            const priceHTML = hasDiscount && originalPrice ? 
              `<span class="total-on-quantity">${quantity > 1 ? `${quantity}x` : ''}</span>
               <s class="cart-item__old-price product-option">${Shopify.formatMoney(originalPrice, "{{amount}}€")}</s>
               <strong class="cart-item__final-price product-option">${Shopify.formatMoney(finalPrice, "{{amount}}€")}</strong>` 
              : 
              `<span class="total-on-quantity">${quantity > 1 ? `${quantity}x` : ''}</span>
               ${Shopify.formatMoney(finalPrice, "{{amount}}€")}`;
            
            // Actualizar SOLO el elemento de precio, no todo el contenido
            cartItem.find('[data-updated-event]').html(priceHTML);
            
          }

          if(quantityOld < quantity){
            window.showToast(window.globalTranslations.successAddToCart, 'success')
          }
        }

        const cart = document.querySelector('cart-drawer');
        if(cart){
          cart.updateCart();
        }

        // Actualizar el precio total del carrito
        $('#total-amount p span').text(`${Shopify.formatMoney(response.total_price, "{{amount}}€")}`);

        $('#checkout-available').hide();
        $('#checkout-unavailable').show();

        localStorage.removeItem('current-cart');

        if (response.items.length) {
          $('#checkout-available').show();
          $('#checkout-unavailable').hide();

          localStorage.setItem('current-cart', JSON.stringify(response.items));
        }

        if (response.item_count) {
          $('#total-on-cart').text(response.item_count);
          $('#total-on-cart').css('display', 'flex');
        } else {
          $('#total-on-cart').css('display', 'none');
        }

        // Disparar evento de actualización del carrito
        handleEventUpdateCart();
      },
      error: function (error) {
        console.error("Error al actualizar el carrito:", error);
          window.showToast(window.globalTranslations.errorAddToCart, 'error')
      },
      complete: function () {
        populateQuantity();
      }
    }) */
  }

  function getSearch(search) {
    console.log('getSearch')
    /* const noImageURL = 'http://cdn.shopify.com/shopifycloud/shopify/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_1800x_crop_center.gif';

    $.ajax({
      type: 'GET',
      url: `/search/suggest.json?q=${search}&resources[type]=product`,
      dataType: 'json',
      beforeSend: function () {
        $('.search-results').removeClass('hidden').html('<p class="text-md text-black"> Searching ...</p>');
        hasProductsOnSearch = false;
        currentProductSelection = 0;
        totalProductOnSearch = 0;
        listProductsSearch = null;
      },
      success: function (data) {
        const products = data?.resources?.results?.products || [];
        let product = '';
        totalProductOnSearch = data?.resources?.results?.products.length - 1;

        if (products.length) {
          for (let i = 0; i < products.length; i++) {
            const currentProduct = products[i];

            product += `
                            <a href="${currentProduct.url}" class="p-2">
                                <div class="flex gap-2 items-center">
                                    <div class="bg-grey-medium10 image rounded">
                                        <div class="bg-grey-medium">
                                            <img src="${currentProduct.image !== null ? currentProduct.image : noImageURL}" alt="" />
                                        </div>
                                    </div>
                                    <div class="flex flex-col gap-2">
                                        <p class="text-lg text-black">${currentProduct.title}</p>
                                    </div>
                                </div>
                            </a>
                        `
          }
          $('.search-results').html(product);

          $('.search-results a').eq(currentProductSelection).addClass('bg-grey-light10');
          listProductsSearch = data?.resources?.results?.products;
          hasProductsOnSearch = true;
        } else {
          $('.search-results').html('<p class="text-md text-black"> No products found.</p>');
          hasProductsOnSearch = false;
        }
      }
    }); */
  }  

  function populateQuantity() {
    console.log('populateQuantity')
    /* var items = JSON.parse(localStorage.getItem('current-cart')) || [];

    items.forEach(item => {
      const hasDiscount = parseFloat(item.discounts[0]?.amount) > 0 ? true : false;
      const variantId = item.id;
      updateProductCardPrice(variantId, item.final_price, hasDiscount)    
    })

    if (items.length) {
      for (var i = 0; i < items.length; i++) {
        var product = $(`.product-description[data-id="${items[i].id}"]`);

        if (window.innerWidth < 500) {
          $(product).find('.reviews-area').hide();
        }

        $(product).find('.list-quantity-inside-product').removeClass('hidden');
        $(product).find('.product-button-add-cart').hide();

        //$(product).find('.list-quantity-inside-product h4').text(items[i].quantity);
      }
    } */
  }

  function updateQuantityOnProduct(variantId) {
    console.log('updateQuantityOnProduct')
    /* $(`#list-cart [data-id="${variantId}"]`).remove();
    $(`.product-description[data-id="${variantId}"]`).find('.list-quantity-inside-product').addClass('hidden');
    $(`.product-description[data-id="${variantId}"]`).find('.product-button-add-cart').show();

    if (window.innerWidth < 500) {
      $(`.product-description[data-id="${variantId}"]`).find('.reviews-area').show();
    } */
  }

  async function getRecommendations(ids) {
    getProductRecommendation(ids[0]).then((data) => {
      for (var i = 0; i < data.products.length; i++) {
        totalProductsRecommendation = data.products.length;
        var recommended = `
                    <div class="item w-[357px] flex h-[100%] rounded-2xl bg-grey-medium overflow-hidden product-description">
                        <div class="flex gap-4 items-center pt-3 pb-2 w-full px-2">
                            <figure class="max-w-[100px] w-24 relative">
                                <img
                                src="${data.products[i].images[0]}"
                                alt=""
                                loading="lazy"
                                class="object-cover invisible" />
                                <div class="absolute bg-grey-medium10" style="background: url(${data.products[i].images[0]}) no-repeat; flex: none; top: 0; width: 100%; max-width: 100px; height: 100%; mix-blend-mode: multiply; background-blend-mode: multiply; background-size: cover; background-position: center;"></div>
                                
                            </figure>
                            <div class="flex flex-col w-44 lg:w-56 gap-1">
                                <span class="bg-[#FBDBCE] py-1 px-3 rounded-[500px] text-primary w-auto text-md self-start">${window.globalTranslations.labelRecommended}</span>
                                <p class="text-black-light text-md text-ellipsis whitespace-nowrap overflow-hidden w-full">${data.products[i].title}</p>
                                <p class="text-black-light text-md">${Shopify.formatMoney(data.products[i].price, "{{amount}}€")}</p>

                                <a class="w-9 h-9 bg-primary rounded-full items-center flex justify-center ml-auto hover:bg-primary40 border-2 border-primary20 add-to-cart group/button cursor-pointer">
                                    <div class="relative w-9 h-9 flex justify-center pointer-events-none">
                                    <img
                                        src=${window.assets.add}
                                        class="w-9 h-9 visible group-hover/button:invisible absolute pointer-events-none"
                                        loading="lazy" />
                                    <img
                                        src=${window.assets.addOrange}
                                        class="w-9 h-9 invisible group-hover/button:visible absolute pointer-events-none"
                                        loading="lazy" />
                                    </div>
                                </a>
                            </div>
                        </div>
                        <input type="hidden" value="${data.products[i].variants[0].id}" name="productId" />
                        <input type="hidden" value="${data.products[i].variants[0].title}" name="productTitle" />
                    </div>
                `;

        // if(loadedCarouselRecomended == false) {
        $('.owl-carousel-recommended-products').append(recommended);
        // }
      }
    }).then(() => {
      if (loadedCarouselRecomended == false) {
        $('#loading-recommendations').hide();
        loadedCarouselRecomended = true;
      } else {
        recomendedCarouselProducts.trigger('destroy.owl.carousel');
      }
      recommendedCarousel();
      $('.owl-carousel-recommended-products').css('opacity', 1);

      $('.owl-carousel-recommended-products .add-to-cart').unbind('click').on('click', (evt) => {
        const parent = $(evt.target).parents('.product-description');
        const ID = $(parent).find('input[name="productId"]').val();

        const quantity = 1;

        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: {
            quantity,
            id: ID
          },
          dataType: 'json',
          success: function () {
            window.showToast(window.globalTranslations.addToCart);
            const cart = document.querySelector('cart-drawer');
            if(cart){
              cart.updateCart();
            }

          //REVISADO: ES DE LAS RECOMENDACIONES DEL CART NO LO TOCO POR AHORA
          console.log('CART:REFRESH 1')
            document.dispatchEvent(new CustomEvent('cart:refresh'));
          },
          error: function (data) {
            window.showToast(data.responseJSON.description, 'error');
          },
          complete: function () {
            getHandleCart();

          }
        });
      });
    });
  }

  function getProductRecommendation(id) {
    return new Promise((resolve, reject) => {
      $.ajax({
        type: 'GET',
        url: `/recommendations/products.json?product_id=${id}&limit=10`,
        dataType: 'json',
        success: function (data) {
          resolve(data)
        },
      });
    })
  }

  //Functions, Plugins, Etc.. Here
  //(does not wait for DOM READY STATE) 

  function recommendedCarousel() {
    recomendedCarouselProducts = $('.owl-carousel-recommended-products').owlCarousel({
      loop: false,
      nav: false,
      dots: false,
      margin: 16,
      autoWidth: true,
      responsive: {
        0: {
          items: 1,
        },
        600: {
          items: 1
        },
        1000: {
          items: 1
        }
      },
      onChanged: (event) => {
        if (event.item.count - event.item.index > 1) {
          $('#arrow-right-orange').show();
          $('#arrow-right-gray').hide();
        } else {
          $('#arrow-right-orange').hide();
          $('#arrow-right-gray').show();
        }

        if (event.item.index !== 0) {
          $('#arrow-left-orange').show();
          $('#arrow-left-gray').hide();
        } else {
          $('#arrow-left-orange').hide();
          $('#arrow-left-gray').show();
        }
      }
    });

    if (totalProductsRecommendation > 1) {
      $('#arrow-right-orange').show();
      $('#arrow-right-gray').hide();
    }
  }

  $(window).on('resize', function () {
    var win = $(this); //this = window

    if ($('.grid-items').hasClass('grid-cols-2')) {
      if (win.width() < 600) {
        $('.grid-items .restriction cite').hide();
      } else {
        $('.grid-items .restriction cite').show();
      }
    }
  });


  // #TODO @pablo. Esto lo dejo comentado ha falta de saber que se hara, ya que con el nuevo header si hace falta mejor rehacemos

  // var lastScroll = 0;
  // $(window).scroll(function () {
  //   var nowScrollTop = $(this).scrollTop();
  //   if (nowScrollTop > lastScroll) {
  //     // code on scrolling down
  //     $('header').removeClass('sticky');
  //     $('body').css('padding-top', 0);
  //   } else {

  //     $('header').addClass('sticky');
  //     $('body').css('padding-top', window.innerWidth < 600 ? 120 : 164);
  //   }

  //   lastScroll = nowScrollTop;
  // });
})(jQuery);
